import React, {useContext, useEffect, useMemo, useState} from "react"
import {AuthContext} from "./auth";
import {ConsoleType} from "../@types/IAuth";
import {getConsolesByEmail} from "../services/api";

export type TUserConsolesProps = {
  children: JSX.Element;
}

export type TUserConsolesState = {
  consoles: ConsoleType[],
  loadingConsoles: boolean;
}

export const UserConsolesContext = React.createContext<TUserConsolesState>({
  consoles: [],
  loadingConsoles: false,
})

export const UserConsolesProvider = ({ children }: TUserConsolesProps) => {
  const { auth, userEmail, token } = useContext(AuthContext)
  const [consoles, setConsoles] = useState<ConsoleType[]>([])
  const [loadingConsoles, setLoadingConsoles] = useState<boolean>()

  useEffect(() => {
    if (auth?.consoles) {
      setConsoles(auth.consoles)
      return;
    }

    updateConsoles()
  }, [auth])

  const updateConsoles = () => {
    setLoadingConsoles(true)
    getConsolesByEmail(userEmail)
      .then((newConsoles) => setConsoles(newConsoles))
      .finally(() => setLoadingConsoles(false))
  }

  const sortedConsoles = useMemo(() => (consoles || [])
      .sort((a, b) => a.name.localeCompare(b.name)), [consoles])

  useEffect(() => {
    if (!loadingConsoles && consoles.length === 1) {
      window.location.assign(`${consoles[0].url}`)
    }

  }, [consoles, loadingConsoles, token])

  return (
    <UserConsolesContext.Provider
      value={{
        consoles: sortedConsoles,
        loadingConsoles
      }}
    >
      {children}
    </UserConsolesContext.Provider>
  )
}